import RouteIcon from "@redotech/redo-icons/route.svg";
import { getProviderDisplayName, Provider } from "@redotech/redo-model/order";
import { ArrayStringFilterOperator } from "@redotech/redo-model/views/advanced-filters/array-string-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import { ArrayStringTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

const OmsProviders = [
  Provider.SHOPIFY,
  Provider.COMMENTSOLD,
  Provider.BIGCOMMERCE,
  Provider.NETSUITE,
  Provider.TIKTOK,
  Provider.AMAZON,
  Provider.WALMART,
  Provider.EBAY,
  Provider.FAIRE,
  Provider.APPAREL_MAGIC,
  Provider.AIMS360,
  Provider.CIN7_OMNI,
  Provider.CIN7_CORE,
  Provider.MANUAL,
  Provider.REDO_MARKETPLACE,
  Provider.WAYFAIR,
];

export const OrderSourceFilter: ArrayStringTableFilter<string> = {
  type: AdvancedFilterType.ARRAY_TO_STRING,
  Icon: RouteIcon,
  operators: [
    ArrayStringFilterOperator.ANY_OF,
    ArrayStringFilterOperator.ALL_OF,
    ArrayStringFilterOperator.NONE_OF,
  ],
  data: {
    name: "source",
    type: AdvancedFilterType.ARRAY_TO_STRING,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  itemLabel: "source",
  itemLabelPlural: "sources",
  values: OmsProviders,
  display: (item: string) => getProviderDisplayName(item as Provider),
  displayName: "Source",
};
